import * as React from 'react';

import { faSpinner, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { InputGroup } from '@shared/components/bootstrap';

import { Step } from '@portal/components/claims/step';

import { ClaimItemSelectionForm } from './form';

export const Declaration = () => (
  <ClaimItemSelectionForm field="declaration">
    {({ loading, selection, onChange }) => (
      <>
        <Step.Title>Please estimate the item’s value.</Step.Title>
        <Step.Subtitle>We’ll automatically round to the nearest dollar.</Step.Subtitle>
        <InputGroup>
          <InputGroup.Prepend>
            <InputGroup.Text>
              {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : <FontAwesomeIcon icon={faDollarSign} />}
            </InputGroup.Text>
          </InputGroup.Prepend>
          <input
            className="form-control"
            type="number"
            min={0}
            max={1000000}
            placeholder="Value"
            onChange={(event) => onChange({ ...selection, declaration: Number(event.target.value) || undefined })}
            value={selection.declaration || ''}
          />
        </InputGroup>
      </>
    )}
  </ClaimItemSelectionForm>
);
